import {
  Blockquote,
  Card,
  CardContent,
  Container,
  Stack,
  Text,
} from "@generalapplications/ui";

import { SectionHeader } from "@/app/common/components/composite/layout/SectionHeader";
import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { homePage } from "@/content/home";
import { formatText } from "@/app/common/functions/format/formatText";

/** The operating thesis: what AI changes, and what engineering still decides. */
export function Thesis() {
  return (
    <Reveal>
      <Card variant="glass" radius="xxl" padding="xl">
        <CardContent gap="xl">
          <SectionHeader
            eyebrow={homePage.thesis.eyebrow}
            title={homePage.thesis.headline}
          />
          <Container width="lg" align="start">
            <Stack gap="md">
              {homePage.thesis.copy.map((paragraph) => (
                <Text key={paragraph} variant="lead">
                  {formatText(paragraph)}
                </Text>
              ))}
            </Stack>
          </Container>
          <Blockquote size="lg">
            <Text variant="inherit" tone="neutral" weight="semibold">
              {formatText(homePage.thesis.pullQuote)}
            </Text>
          </Blockquote>
        </CardContent>
      </Card>
    </Reveal>
  );
}
